import { timeline } from "@/mocks/gossipData";

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">Recent Updates</p>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              近期动态时间线
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              吃瓜最怕断片。我们把本周焦点事件的最新进展按时间顺序梳理成线，
              让你一眼看清「现在进行到哪一步」，补上中间错过的每一环。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              <div className="rounded-lg bg-background-100 p-4 ring-1 ring-background-200">
                <p className="text-xs text-foreground-500">近7天跟进事件</p>
                <p className="font-heading mt-1 text-2xl font-black text-primary-600">12 起</p>
              </div>
              <div className="rounded-lg bg-accent-100 p-4 ring-1 ring-accent-200">
                <p className="text-xs text-accent-800">每日更新频次</p>
                <p className="font-heading mt-1 text-2xl font-black text-accent-800">持续在线</p>
              </div>
            </div>

            <a
              href="#subscribe"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-200 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              想看完整每周盘点
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <ol className="relative ml-2 space-y-5 border-l-2 border-background-200">
            {timeline.map((t) => (
              <li key={t.date + t.topic} className="relative pl-6">
                <span className="absolute -left-[9px] top-1 flex h-4 w-4 items-center justify-center rounded-full bg-background-50 ring-2 ring-primary-500">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                </span>
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-xs font-semibold text-primary-700 ring-1 ring-primary-200">
                    {t.topic}
                  </span>
                  <span className="text-xs text-foreground-400">{t.date}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{t.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}